import type { RichTextAnswerFragment } from '../../../present/activity-answers.graphql.generated';
import { FillInBlanksResponseAnswer } from '../fill-in-blanks.constants';

export function getFillInBlanksRichtext(
  answer: FillInBlanksResponseAnswer | null | undefined
) {
  return (answer?.answer as RichTextAnswerFragment)?.richtext;
}
